/*
 * Copyright (c) 2023
 * 
 * Created Date: Thursday, July 27th 2023, 6:09:56 pm
 * Author: 🫰Aris Bimas Nugroho
 * 
 */
import React from 'react';
import { Button, Result } from 'antd';
import { useNavigate } from 'react-router-dom';
import { APP_ROUTE_PREFIX } from 'routes/routesConstant';
const Error403 = () => {
  const nav = useNavigate();
  return (
    <Result
      status="403"
      title="401"
      subTitle="Sorry, you are not authorized to access this page."
      extra={<Button type="primary" onClick={() => nav(APP_ROUTE_PREFIX + "/dashboard", { replace: true })}>Back Dashboard</Button>}
    />
  );
}
export default Error403;
